import { useState } from 'react'

/**
 * Values and methods are used by the context API
 * @returns states being used to manipulate the scene
 */

export const useStateNight = () => {
  const [night, setNight] = useState(false)

  const onHandleNight = (value: boolean) => {
    setNight(value)
  }

  return {
    night: {
      night: night,
    },

    nightMethod: {
      onHandleNight,
    },
  }
}
